/* TourStock flight case label renderer, shared by the storefront designer
 * (ts-label-builder.js) and the Growth OS print-file renderer on the server.
 * Everything is drawn in millimetres on a 210 x 150 label, so the proof the
 * customer sees and the print file made after the order come from the same
 * code. Keep this file free of DOM and Node specific calls. */
(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.TLBCore = factory();
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  var W = 210;
  var H = 150;
  var M = 7;

  var FONTS = {
    condensed: {
      name: "Condensed",
      family: '"Barlow Condensed", "Arial Narrow", Arial, sans-serif',
      weight: 700,
    },
    heavy: {
      name: "Heavy",
      family: 'Archivo, "Arial Black", Arial, sans-serif',
      weight: 800,
    },
    clean: {
      name: "Clean",
      family: 'Lato, Helvetica, Arial, sans-serif',
      weight: 700,
    },
    oswald: {
      name: "Oswald",
      family: 'Oswald, "Arial Narrow", Arial, sans-serif',
      weight: 600,
    },
    robotocond: {
      name: "Roboto Condensed",
      family: '"Roboto Condensed", "Arial Narrow", Arial, sans-serif',
      weight: 700,
    },
    bebas: {
      name: "Bebas Neue",
      family: '"Bebas Neue", "Arial Narrow", Arial, sans-serif',
      weight: 400,
      fixed: true,
    },
    anton: {
      name: "Anton",
      family: 'Anton, "Arial Narrow", Arial, sans-serif',
      weight: 400,
      fixed: true,
    },
    montserrat: {
      name: "Montserrat",
      family: 'Montserrat, Helvetica, Arial, sans-serif',
      weight: 800,
    },
    nunito: {
      name: "Rounded",
      family: 'Nunito, Helvetica, Arial, sans-serif',
      weight: 800,
    },
    slab: {
      name: "Slab serif",
      family: '"Roboto Slab", Georgia, serif',
      weight: 700,
    },
    stencil: {
      name: "Stencil",
      family: '"Saira Stencil One", Impact, sans-serif',
      weight: 400,
      fixed: true,
    },
    marker: {
      name: "Marker",
      family: '"Permanent Marker", "Comic Sans MS", cursive',
      weight: 400,
      fixed: true,
    },
  };
  var GHOST_HEADING = "YOUR TOUR NAME";
  var GHOST_SUB = "Production company";

  function clamp(n, lo, hi) {
    return Math.min(hi, Math.max(lo, n));
  }

  function rgb(hex) {
    var h = hex.replace("#", "");
    if (h.length === 3) h = h.split("").map(function (c) { return c + c; }).join("");
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function lum(hex) {
    var c = rgb(hex).map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function contrast(bg) {
    return lum(bg) > 0.4 ? "#111111" : "#ffffff";
  }

  function rgba(hex, a) {
    return "rgba(" + rgb(hex).join(",") + "," + a + ")";
  }

  function create(S) {
  function onAccent() {
    return lum(S.accent) > 0.4 ? "#111111" : S.bg;
  }

    function rr(ctx, x, y, w, h, r) {
      r = Math.max(0, Math.min(r, w / 2, h / 2));
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function fontCss(size, weight) {
      var f = FONTS[S.font];
      return (f.fixed ? f.weight : weight || f.weight) + " " + size + "px " + f.family;
    }

    function wrapLines(ctx, text, maxW) {
      var words = text.split(/\s+/).filter(Boolean);
      if (!words.length) return [];
      var lines = [];
      var line = "";
      for (var i = 0; i < words.length; i += 1) {
        var test = line ? line + " " + words[i] : words[i];
        if (ctx.measureText(test).width <= maxW) {
          line = test;
        } else {
          if (!line) return null;
          lines.push(line);
          line = words[i];
          if (ctx.measureText(line).width > maxW) return null;
        }
      }
      lines.push(line);
      return lines;
    }

    function fitText(ctx, text, maxW, maxH, maxSize, maxLines, minSize, weight) {
      for (var s = maxSize; s >= minSize; s -= 0.5) {
        ctx.font = fontCss(s, weight);
        var lines = wrapLines(ctx, text, maxW);
        if (lines && lines.length <= maxLines && lines.length * s * 1.1 <= maxH + 0.01) {
          return { lines: lines, size: s };
        }
      }
      ctx.font = fontCss(minSize, weight);
      var t = text;
      while (t.length > 1 && ctx.measureText(t + "\u2026").width > maxW) t = t.slice(0, -1);
      return { lines: [t + "\u2026"], size: minSize };
    }

    var LINES = [0.35, 0.55, 0.9];
    var LEVELS = [1, 1.7, 2.6, 0.7];
    var HEAD = {
      banner: { def: 40, min: 26, max: 80 },
      classic: { def: 40, min: 26, max: 80 },
      sidebar: { def: 40, min: 26, max: 80 },
      centred: { def: 66, min: 44, max: 100 },
    };
    var SIDE = { def: 22, min: 12, max: 44 };
    var MIN_ROW = 13;
    var MAX_ROW = 55;
    var MIN_BOX_W = 21;

    function headRange(layout) {
      return HEAD[layout] || HEAD.banner;
    }
    function headH(layout) {
      var r = headRange(layout);
      return clamp(typeof S.headH === "number" ? S.headH : r.def, r.min, r.max);
    }
    function sideW() {
      return clamp(typeof S.sideW === "number" ? S.sideW : SIDE.def, SIDE.min, SIDE.max);
    }
    function lineW() {
      return LINES[S.lineW] || LINES[1];
    }
    function titleScale() {
      return clamp(typeof S.titleScale === "number" ? S.titleScale : 100, 50, 140) / 100;
    }
    /* With nothing to print as a title, a logo takes the whole header. */
    function textual(layout) {
      return !!S.heading.trim() || (layout !== "sidebar" && !!S.sub.trim());
    }
    function alignFor(layout) {
      if (S.align === "left" || S.align === "centre" || S.align === "right") return S.align;
      return layout === "centred" ? "centre" : "left";
    }
    function level(f) {
      return typeof f.h === "number" ? f.h : f.tall ? 1 : 0;
    }

    function geometry(layout, hasLogo) {
      var g = { logoBox: null, textBox: null, rule: null, fields: null, vertical: null, strips: [], align: alignFor(layout), layout: layout };
      var side = S.logoSide === "right" ? "right" : "left";
      var logoOnly = !!hasLogo && !textual(layout);
      g.logoOnly = logoOnly;
      var hh = headH(layout);
      var lw;
      var gap;
      if (layout === "banner") {
        var ch = hh - 10;
        lw = hasLogo ? (logoOnly ? W - 2 * M : 52) : 0;
        gap = hasLogo && !logoOnly ? 6 : 0;
        g.band = { x: 0, y: 0, w: W, h: hh };
        if (hasLogo) g.logoBox = { x: side === "left" || logoOnly ? M : W - M - lw, y: 5, w: lw, h: ch };
        g.textBox = { x: side === "left" ? M + lw + gap : M, y: 5, w: W - 2 * M - lw - gap, h: ch };
        g.headColour = onAccent();
        g.headHex = g.headColour;
        g.subColour = g.headColour;
        g.panel = S.logoPanel;
        g.fields = { x: M, y: hh + 6, w: W - 2 * M, h: H - M - (hh + 6) };
      } else if (layout === "classic" || layout === "sidebar") {
        var sw = sideW();
        var x0 = layout === "sidebar" ? sw + M : M;
        var inner = W - x0 - M;
        var bh = hh - M - 3;
        lw = hasLogo ? (logoOnly ? inner : layout === "sidebar" ? 44 : 50) : 0;
        gap = hasLogo && !logoOnly ? 6 : 0;
        if (layout === "sidebar") {
          g.band = { x: 0, y: 0, w: sw, h: H };
          g.vertical = { x: sw / 2, w: H - 2 * M, colour: onAccent() };
        }
        if (hasLogo) g.logoBox = { x: side === "left" || logoOnly ? x0 : x0 + inner - lw, y: M, w: lw, h: bh };
        g.textBox = { x: side === "left" ? x0 + lw + gap : x0, y: M, w: inner - lw - gap, h: bh };
        g.headColour = S.text;
        g.headHex = S.text;
        g.subColour = rgba(S.text, 0.75);
        g.rule = { x: x0, y: hh, w: inner, h: 1.6 };
        g.fields = { x: x0, y: hh + 1.6 + 6, w: inner, h: H - M - (hh + 1.6 + 6) };
      } else {
        var cc = hh - 16;
        g.strips = [
          { x: 0, y: 0, w: W, h: 5 },
          { x: 0, y: H - 5, w: W, h: 5 },
        ];
        if (hasLogo && logoOnly) {
          g.logoBox = { x: M, y: 10, w: W - 2 * M, h: cc };
          g.textBox = { x: M, y: 10, w: W - 2 * M, h: cc };
        } else if (hasLogo) {
          var lh = Math.round(cc * 0.52 * 10) / 10;
          g.logoBox = { x: (W - 72) / 2, y: 10, w: 72, h: lh };
          g.textBox = { x: M, y: 10 + lh + 2, w: W - 2 * M, h: cc - lh - 2 };
        } else {
          g.textBox = { x: M, y: 10, w: W - 2 * M, h: cc };
        }
        g.headColour = S.text;
        g.headHex = S.text;
        g.subColour = rgba(S.text, 0.75);
        g.fields = { x: M, y: hh, w: W - 2 * M, h: H - 5 - 6 - hh };
      }
      return g;
    }

    function logoPlacement(g, layout) {
      var L = S.logo;
      if (!L || !g.logoBox) return null;
      var box = g.logoBox;
      var pad = g.panel ? 2 : 0;
      var iw = box.w - 2 * pad;
      var ih = box.h - 2 * pad;
      var k = Math.min(iw / L.w, ih / L.h) * (S.logoScale / 100);
      var dw = L.w * k;
      var dh = L.h * k;
      var dx;
      if (layout === "centred" || (g.panel && !g.logoOnly) || S.logoSide === "centre") dx = box.x + (box.w - dw) / 2;
      else if (S.logoSide === "right") dx = box.x + box.w - dw - pad;
      else dx = box.x + pad;
      return { x: dx, y: box.y + (box.h - dh) / 2, w: dw, h: dh };
    }

    function freePlacement() {
      var L = S.logo;
      var f = S.logoFree;
      if (!L || !f) return null;
      var dw = Math.min(f.w, W - 2);
      var dh = (dw * L.h) / L.w;
      if (dh > H - 2) {
        dh = H - 2;
        dw = (dh * L.w) / L.h;
      }
      var cx = clamp(f.x, dw / 2, W - dw / 2);
      var cy = clamp(f.y, dh / 2, H - dh / 2);
      return { x: cx - dw / 2, y: cy - dh / 2, w: dw, h: dh };
    }

    /* Boxes flow in order into rows of 12 columns. When the space left is too
       short to write in, rows take more columns (so boxes get narrower and more
       fit per row) until the rows are tall enough or the boxes get too narrow. */
    function pack(items, cap) {
      var rows = [];
      var cur = null;
      var used = 0;
      items.forEach(function (f) {
        var span = Math.min(f.span, cap);
        if (!cur || used + span > cap) {
          cur = { items: [], weight: 0 };
          rows.push(cur);
          used = 0;
        }
        cur.items.push({ f: f, span: span });
        used += span;
        cur.weight = Math.max(cur.weight, LEVELS[level(f)] || 1);
      });
      return rows;
    }

    function flowFields(box) {
      var items = S.fields.filter(function (f) { return f.on; });
      if (!items.length) return [];
      var gapX = 2.5;
      var gapY = 2.5;
      var caps = [12, 14, 16, 18, 20, 24];
      var rows = pack(items, 12);
      var cap = 12;
      function unitFor(rs) {
        var weights = rs.reduce(function (a, r) { return a + r.weight; }, 0);
        return (box.h - gapY * (rs.length - 1)) / weights;
      }
      function narrowest(rs) {
        var min = Infinity;
        rs.forEach(function (row) {
          var sum = row.items.reduce(function (a, it) { return a + it.span; }, 0);
          var usable = box.w - gapX * (row.items.length - 1);
          row.items.forEach(function (it) { min = Math.min(min, (usable * it.span) / sum); });
        });
        return min;
      }
      for (var i = 1; i < caps.length && unitFor(rows) < MIN_ROW; i += 1) {
        var tryRows = pack(items, caps[i]);
        if (narrowest(tryRows) < MIN_BOX_W) break;
        rows = tryRows;
        cap = caps[i];
      }
      var unit = Math.min(unitFor(rows), MAX_ROW);
      var out = [];
      var y = box.y;
      rows.forEach(function (row) {
        var rh = unit * row.weight;
        var spanSum = row.items.reduce(function (a, it) { return a + it.span; }, 0);
        var usable = box.w - gapX * (row.items.length - 1);
        var x = box.x;
        row.items.forEach(function (it) {
          var bw = (usable * it.span) / spanSum;
          out.push({ f: it.f, x: x, y: y, w: bw, h: rh });
          x += bw + gapX;
        });
        y += rh + gapY;
      });
      out.cap = cap;
      out.unit = unit;
      out.rows = rows.length;
      return out;
    }

    function drawLabel(ctx, ppm, o) {
      o = o || {};
      var layout = o.layout || S.layout;
      var hasLogo = !!S.logo;
      var g = geometry(layout, hasLogo && !S.logoFree);
      ctx.save();
      ctx.setTransform(ppm, 0, 0, ppm, 0, 0);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.textBaseline = "middle";
      ctx.fillStyle = S.bg;
      ctx.fillRect(0, 0, W, H);

      if (g.band) {
        ctx.fillStyle = S.accent;
        ctx.fillRect(g.band.x, g.band.y, g.band.w, g.band.h);
      }
      g.strips.forEach(function (s) {
        ctx.fillStyle = S.accent;
        ctx.fillRect(s.x, s.y, s.w, s.h);
      });
      if (g.rule) {
        ctx.fillStyle = S.accent;
        ctx.fillRect(g.rule.x, g.rule.y, g.rule.w, g.rule.h);
      }

      var place = logoPlacement(g, layout);
      if (g.logoBox && g.panel) {
        var pr = g.logoOnly && place ? { x: place.x - 2, y: place.y - 2, w: place.w + 4, h: place.h + 4 } : g.logoBox;
        ctx.fillStyle = S.bg;
        rr(ctx, pr.x, pr.y, pr.w, pr.h, 2);
        ctx.fill();
      }
      if (place) paintLogo(ctx, o, place);

      drawHeading(ctx, g, o.ghost && !hasLogo);

      if (g.vertical && S.sub.trim()) {
        var vt = S.caps ? S.sub.trim().toUpperCase() : S.sub.trim();
        var sw = sideW();
        var fit = fitText(ctx, vt, g.vertical.w, Math.max(5, sw - 8), Math.max(4.5, (9 * sw) / 22), 1, 4);
        ctx.save();
        ctx.translate(g.vertical.x, H / 2);
        ctx.rotate(-Math.PI / 2);
        ctx.textAlign = "center";
        ctx.fillStyle = g.vertical.colour;
        ctx.font = fontCss(fit.size);
        ctx.fillText(fit.lines[0], 0, 0);
        ctx.restore();
      }

      flowFields(g.fields).forEach(function (b) {
        ctx.lineWidth = lineW();
        ctx.strokeStyle = rgba(S.text, 0.75);
        rr(ctx, b.x, b.y, b.w, b.h, 1.6);
        ctx.stroke();
        var cap = (b.f.caption || "").trim();
        if (o.selectUid && o.selectUid === b.f.uid) {
          ctx.fillStyle = "rgba(29,78,216,0.10)";
          rr(ctx, b.x, b.y, b.w, b.h, 1.6);
          ctx.fill();
          ctx.lineWidth = 0.7;
          ctx.strokeStyle = "rgba(29,78,216,0.95)";
          ctx.stroke();
        }
        if (o.dropUid && o.dropUid === b.f.uid) {
          ctx.setLineDash([1.4, 1]);
          ctx.lineWidth = 0.9;
          ctx.strokeStyle = "rgba(29,78,216,1)";
          rr(ctx, b.x - 0.8, b.y - 0.8, b.w + 1.6, b.h + 1.6, 2);
          ctx.stroke();
          ctx.setLineDash([]);
        }
        if (!cap) return;
        if (S.caps) cap = cap.toUpperCase();
        var cf = fitText(ctx, cap, b.w - 4, 4, 3.6, 1, 2.4, 700);
        ctx.fillStyle = rgba(S.text, 0.8);
        ctx.textAlign = "left";
        ctx.font = fontCss(cf.size, 700);
        ctx.fillText(cf.lines[0], b.x + 2, b.y + 2.2 + cf.size * 0.5);
      });

      var free = freePlacement();
      if (free) {
        if (S.logoPanel) {
          ctx.fillStyle = S.bg;
          rr(ctx, free.x - 2, free.y - 2, free.w + 4, free.h + 4, 2);
          ctx.fill();
        }
        paintLogo(ctx, o, free);
        if (o.handles) {
          ctx.setLineDash([1.2, 1.2]);
          ctx.lineWidth = 0.35;
          ctx.strokeStyle = "rgba(29,78,216,0.85)";
          ctx.strokeRect(free.x - 1, free.y - 1, free.w + 2, free.h + 2);
          ctx.setLineDash([]);
          ctx.fillStyle = "rgba(29,78,216,0.95)";
          ctx.fillRect(free.x + free.w - 0.6, free.y + free.h - 0.6, 3.2, 3.2);
        }
      }

      if (o.watermark) drawWatermark(ctx);

      if (o.sizeHandles) {
        ctx.strokeStyle = "rgba(29,78,216,0.85)";
        ctx.fillStyle = "rgba(29,78,216,0.95)";
        ctx.lineWidth = 0.4;
        sizeHandles(layout).forEach(function (h) {
          ctx.setLineDash([1.6, 1.2]);
          ctx.beginPath();
          if (h.axis === "y") {
            ctx.moveTo(h.from, h.pos);
            ctx.lineTo(h.to, h.pos);
          } else {
            ctx.moveTo(h.pos, h.from);
            ctx.lineTo(h.pos, h.to);
          }
          ctx.stroke();
          ctx.setLineDash([]);
          var cx = h.axis === "y" ? (h.from + h.to) / 2 : h.pos;
          var cy = h.axis === "y" ? h.pos : (h.from + h.to) / 2;
          if (h.axis === "y") rr(ctx, cx - 6, cy - 1.6, 12, 3.2, 1.6);
          else rr(ctx, cx - 1.6, cy - 6, 3.2, 12, 1.6);
          ctx.fill();
        });
      }

      if (o.guides) {
        ctx.setLineDash([1.2, 1.2]);
        ctx.lineWidth = 0.3;
        ctx.strokeStyle = "rgba(214,40,40,0.7)";
        ctx.strokeRect(M, M, W - 2 * M, H - 2 * M);
        ctx.setLineDash([]);
      }
      ctx.restore();
    }

    /* The edges of the header (and the side bar) that can be dragged. */
    function sizeHandles(layout) {
      var list = [];
      var hh = headH(layout);
      if (layout === "banner") list.push({ id: "head", axis: "y", pos: hh, from: 0, to: W });
      else if (layout === "classic" || layout === "sidebar") {
        var x0 = layout === "sidebar" ? sideW() + M : M;
        list.push({ id: "head", axis: "y", pos: hh, from: x0, to: W - M });
      } else list.push({ id: "head", axis: "y", pos: hh - 3, from: M, to: W - M });
      if (layout === "sidebar") list.push({ id: "side", axis: "x", pos: sideW(), from: 0, to: H });
      return list;
    }

    function drawHeading(ctx, g, ghost) {
      var tb = g.textBox;
      var heading = S.heading.trim();
      var sub = S.sub.trim();
      var ghostHead = false;
      var ghostSub = false;
      if (!heading && ghost) {
        heading = GHOST_HEADING;
        ghostHead = true;
      }
      if (!sub && ghost && !g.vertical) {
        sub = GHOST_SUB;
        ghostSub = true;
      }
      if (g.vertical) sub = "";
      if (!heading && !sub) return;
      if (S.caps) {
        heading = heading.toUpperCase();
        sub = sub.toUpperCase();
      }
      var scale = titleScale();
      var subSize = 0;
      var subLine = "";
      var subGap = 0;
      if (sub) {
        var sf = fitText(ctx, sub, tb.w, 7, Math.max(3.4, 5.6 * Math.min(scale, 1.25)), 1, 3.4, 600);
        subSize = sf.size;
        subLine = sf.lines[0];
        subGap = 1.6;
      }
      var maxHead = Math.max(4.5, (g.layout === "centred" ? 11 : 13) * scale);
      var hf = heading
        ? fitText(ctx, heading, tb.w, tb.h - (subSize ? subSize * 1.1 + subGap : 0), maxHead, 2, 4.5)
        : { lines: [], size: 0 };
      var headBlock = hf.lines.length * hf.size * 1.1;
      var total = headBlock + (subSize ? subGap + subSize * 1.1 : 0);
      var y = tb.y + (tb.h - total) / 2;
      var x = g.align === "centre" ? tb.x + tb.w / 2 : g.align === "right" ? tb.x + tb.w : tb.x;
      ctx.textAlign = g.align === "centre" ? "center" : g.align === "right" ? "right" : "left";
      ctx.font = fontCss(hf.size);
      ctx.fillStyle = ghostHead ? rgba(g.headHex, 0.35) : g.headColour;
      hf.lines.forEach(function (line, i) {
        ctx.fillText(line, x, y + (i + 0.5) * hf.size * 1.1);
      });
      if (subSize) {
        ctx.font = fontCss(subSize, 600);
        ctx.fillStyle = ghostSub ? rgba(g.headHex, 0.35) : g.subColour;
        ctx.fillText(subLine, x, y + headBlock + subGap + subSize * 0.55);
      }
    }

    /* Hit-testing data for the designer: where everything sits right now. */
    function inspect(layout) {
      layout = layout || S.layout;
      var g = geometry(layout, !!S.logo && !S.logoFree);
      return {
        g: g,
        boxes: flowFields(g.fields),
        handles: sizeHandles(layout),
        range: headRange(layout),
        side: SIDE,
        hasText: textual(layout),
      };
    }

    /* The server collects the placement and embeds the logo itself, because
       an SVG canvas cannot carry a drawn image. */
    function paintLogo(ctx, o, p) {
      if (o.logoSink) o.logoSink(p);
      else ctx.drawImage(S.logo.img, p.x, p.y, p.w, p.h);
    }

    function drawWatermark(ctx) {
      var dark = lum(S.bg) > 0.4;
      ctx.save();
      ctx.beginPath();
      ctx.rect(0, 0, W, H);
      ctx.clip();
      ctx.translate(W / 2, H / 2);
      ctx.rotate(-Math.PI / 6);
      ctx.fillStyle = dark ? "rgba(17,17,17,0.13)" : "rgba(255,255,255,0.2)";
      ctx.font = "800 15px Arial, Helvetica, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      var row = 0;
      for (var y = -170; y <= 170; y += 34) {
        var off = row % 2 ? 36 : 0;
        for (var x = -300; x <= 300; x += 72) ctx.fillText("PROOF", x + off, y);
        row += 1;
      }
      ctx.restore();
    }

    return {
      drawLabel: drawLabel,
      geometry: geometry,
      freePlacement: freePlacement,
      logoPlacement: logoPlacement,
      onAccent: onAccent,
      inspect: inspect,
      textual: textual,
    };
  }

  return {
    W: W,
    H: H,
    M: M,
    FONTS: FONTS,
    GHOST_HEADING: GHOST_HEADING,
    GHOST_SUB: GHOST_SUB,
    clamp: clamp,
    rgb: rgb,
    lum: lum,
    contrast: contrast,
    rgba: rgba,
    create: create,
  };
});
